import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //售后-调整名义-列表
  configFeeTypeList: (data) => apiAxios('post', baseURL + '/aftersale.configFeeTypeList', data),
  //售后-调整名义-设置
  configFeeTypeSet: (data) => apiAxios('post', baseURL + '/aftersale.configFeeTypeSet', data),
  //售后-调整名义-删除
  configFeeTypeDelete: (data) => apiAxios('post', baseURL + '/aftersale.configFeeTypeDelete', data),
  //售后-调整原因-列表
  configReasonList: (data) => apiAxios('post', baseURL + '/aftersale.configReasonList', data),
  //售后-调整原因-设置
  configReasonSet: (data) => apiAxios('post', baseURL + '/aftersale.configReasonSet', data),
  //售后-调整原因-删除
  configReasonDelete: (data) => apiAxios('post', baseURL + '/aftersale.configReasonDelete', data),
  //售后-售后列表
  aftersaleList: (data) => apiAxios('post', baseURL + '/aftersale.list', data),
  //售后-售后列表-tab数据
  listTab: (data) => apiAxios('post', baseURL + '/aftersale.listTab', data),

  //售后-售后详情
  aftersaleDetail: (data) => apiAxios('post', baseURL + '/aftersale.detail', data),

  //售后-赔款单-获取赔款类型选项
  reparationReason: (data) => apiAxios('post', baseURL + '/aftersale.reparationReason', data),
  //售后-整单-提出预览
  porderWholePreview: (data) => apiAxios('post', baseURL + '/aftersale.porderWholePreview', data),
  //售后-整单-提出
  porderWholeUpdate: (data) => apiAxios('post', baseURL + '/aftersale.porderWholeUpdate', data),
  //售后-整单-修改
  porderWholeStore: (data) => apiAxios('post', baseURL + '/aftersale.porderWholeStore', data),
  //售后-整单-确认
  porderWholeConfirm: (data) => apiAxios('post', baseURL + '/aftersale.porderWholeConfirm', data),
  //售后-整单-完成
  porderWholeComplete: (data) => apiAxios('post', baseURL + '/aftersale.porderWholeComplete', data),
  //售后-售后单删除(不区分售后单类型)
  afterSaleDelete: (data) => apiAxios('post', baseURL + '/aftersale.afterSaleDelete', data),

  //售后-商品-提出预览
  porderGoodsPreview: (data) => apiAxios('post', baseURL + '/aftersale.porderGoodsPreview', data),
  //售后-商品-提出
  porderGoodsStore: (data) => apiAxios('post', baseURL + '/aftersale.porderGoodsStore', data),
  //  售后-商品-修改
  porderGoodsUpdate: (data) => apiAxios('post', baseURL + '/aftersale.porderGoodsUpdate', data),
  // 售后-商品-售后单确认
  porderGoodsConfirm: (data) => apiAxios('post', baseURL + '/aftersale.porderGoodsConfirm', data),

  //售后-商品-商品各项费用退费规则类型选项
  amountRefundType: (data) => apiAxios('post', baseURL + '/aftersale.amountRefundType', data),
  //售后-提出校验是否有重复金额的记录
  checkRepeatAfterSale: (data) => apiAxios('post', baseURL + '/aftersale.checkRepeatAfterSale', data),



  //售后-赔款单-获取新赔款单号
  getNewReparationSn: (data) => apiAxios('post', baseURL + '/aftersale.getNewReparationSn', data),
  //售后-赔款单-添加
  storeReparation: (data) => apiAxios('post', baseURL + '/aftersale.storeReparation', data),
  //    售后-赔款单-修改
  updateReparation: (data) => apiAxios('post', baseURL + '/aftersale.updateReparation', data),
  //售后-赔款单-确认
  confirmReparation: (data) => apiAxios('post', baseURL + '/aftersale.confirmReparation', data),
  //售后-赔款单-删除
  deleteReparation: (data) => apiAxios('post', baseURL + '/aftersale.deleteReparation', data),
  //售后-赔款单-完成
  porderGoodsComplete: (data) => apiAxios('post', baseURL + '/aftersale.porderGoodsComplete', data),

  // 售后-赔款单-主责任人类型MAP
  liableType: (data) => apiAxios('post', baseURL + '/aftersale.reparation.liableType', data),
  // 售后- 赔款单 - 赔款主体类型MAP
  reparationAmountType: (data) => apiAxios('post', baseURL + '/aftersale.reparation.reparationAmountType', data),

  // 售后- 赔款单-列表
  reparationList: (data) => apiAxios('post', baseURL + '/aftersale.reparationList', data),
  // 售后-赔款单-添加
  storeReparation: (data) => apiAxios('post', baseURL + '/aftersale.storeReparation', data),
  // 售后- 赔款单-修改
  updateReparation: (data) => apiAxios('post', baseURL + '/aftersale.updateReparation', data),
  // 售后-赔款单-确认
  confirmReparation: (data) => apiAxios('post', baseURL + '/aftersale.confirmReparation', data),
  // 售后赔款单-删除
  deleteReparation: (data) => apiAxios('post', baseURL + '/aftersale.deleteReparation', data),
  // 售后-赔款单-查询配送单出货金额
  porderDeliveryDetail: (data) => apiAxios('post', baseURL + '/aftersale.porderDeliveryDetail', data),

  // // PayPal官方l账单列表
  // payPalBillList: (data) => apiAxios('post', baseURL + '/palPal.payPalBillList', data),
  // // PayPal官方账单详情
  // payPalBillDetail: (data) => apiAxios('post', baseURL + '/palPal.payPalBillDetail', data),
  // PayPal异常账单核对
  payPalAbnormalBillList: (data) => apiAxios('post', baseURL + '/palPal.payPalAbnormalBillList', data),
  //根据理应赔款计算金额
  getReparationsByUser: (data) => apiAxios('get', 'https://img.rakumart-oem.com/api/getReparationsByUser', data),


}